import React from 'react';
import { withRouter, useHistory } from 'react-router-dom';

import {
    Box, Grid,
    Button, IconButton,
    TextField, Select, MenuItem,
    FormHelperText, FormControl, FormControlLabel,
    RadioGroup, Radio, Checkbox,
    Dialog, DialogTitle, DialogContent,
    InputAdornment, LinearProgress
} from '@material-ui/core';
import { useStyles } from "./styles";
import * as Icons from "./iconComponents";
import { useFormContext, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import IndexedDb from './IndexedDb';
const Popup: React.FC<any> = ({ popState, setPopState, onSubmit, disabled, visibileProgress,setPdfname }): JSX.Element => {
    const classes = useStyles();

    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useFormContext();
    const pcrType = watch("pcr_type");
    const [Indexdb, setIndexdb] = React.useState("");
    const [Otherstaff, setOtherstaff] = React.useState("");
    const { authStore } = useSelector((state: RootState) => state);
    const formData = new FormData();
    React.useEffect(() => {
        let db: any = null;
        db = localStorage.getItem("PatientDB");
        setIndexdb(db);
        getindexdbvalues();
    }, [])
    const getindexdbvalues = async (): Promise<void> => {
        let db: any = null;
        let date: Date = new Date();
        let observationdata = null;
        db = localStorage.getItem("PatientDB");
        if (db != null && db != "") {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            let val = await indexedDb.getAllValue('Handover');
            for (let i = 0; i < val.length; i++) {
                if (val[i].Key == "Otherstaff") {
                    setOtherstaff(val[i].value.column);
                    setValue("other_staff", val[i].value.column);
                }

            }
        }
    }
    const handleindexdbsave = async (Key: any, value: any): Promise<void> => {
        let values = getValues();

        if (Indexdb != null || Indexdb != "") {
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            await indexedDb.deleteValue('Handover', Key);
            await indexedDb.putValue('Handover', { column: value, Patid: 0 }, Key);
        }
    }  
    return (
        <>
            {popState && (<>

                <Dialog
                    open={popState}
                    onClose={() => setPopState(!popState)}
                    className={classes.pcrDialog}
                    fullWidth
                >
                    <DialogTitle disableTypography style={{paddingBottom:10, display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        Sign Off PCR
                        <IconButton className={"closeButton"} onClick={() => setPopState(!popState)}>
                            <Icons.CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent style={{paddingTop:10}}>
                        <Grid container className={classes.pcrSubmitPopup} spacing={2}>
                            {/* <Grid item xs={12} sm={12}>
                                <div className={classes.formControlLabel}>
                                    Submitter:
                                </div>
                                <div className={"submitter"}>
                                    <div className={"name"}>
                                        {authStore.data?.givenName}
                                    </div>
                                    <div className={"email"}>
                                        {authStore.data?.email}
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <div className={classes.formControlLabel}>
                                    Other staff that provided care:
                                </div>
                                <Controller
                                    control={control}
                                    name="other_staff"
                                    //  defaultValue={Otherstaff}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <TextField
                                            variant='outlined'
                                            value={value}
                                            onChange={e => {
                                                onChange(e)
                                            }}
                                            InputProps={{ classes: { root: classes.multilinetextFieldInput } }}
                                            error={errors.other_staff} helperText={errors.other_staff ? errors.other_staff.message : ""}
                                            placeholder="List names (one per line)..."
                                            multiline={true}
                                            rows={4}
                                            onBlur={(e) =>
                                                handleindexdbsave('Otherstaff', e.target.value)
                                            }
                                        />
                                    )}
                                    rules={{
                                        //required: "This field is required",
                                    }}
                                />
                            </Grid> */}
                            <Grid item xs={12} sm={12}>
                                <Controller
                                    control={control}
                                    name="confirm_true"
                                    defaultValue={false}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <FormControl fullWidth error={errors.confirm_true}>
                                                <FormControlLabel
                                                    control={<Checkbox className={classes.checkboxInput} />}
                                                    label='I confirm that all information supplied is true and correct and that any information omitted is not relevant.'
                                                    checked={value}
                                                    onChange={(e: any) => { onChange(!value) }}
                                                />
                                                <FormHelperText>{errors.confirm_true ? errors.confirm_true.message : ""}</FormHelperText>
                                            </FormControl>
                                        </>
                                    )}
                                    rules={{
                                        required: "Please check the above",
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6} sm={6}>
                                        <Button fullWidth disabled={disabled} className={classes.whiteBtn} type="button" onClick={() => setPopState(!popState)}>
                                            Cancel
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6} sm={6}>
                                        <Button fullWidth disabled={disabled} className={classes.yellowBtn} type="button" onClick={onSubmit}>
                                            Submit
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {disabled &&
                                <Grid item xs={12} sm={12}>
                                    <Box style={{ width: '100%' }}>
                                        <LinearProgress />
                                    </Box>
                                </Grid>
                            }
                        </Grid>


                    </DialogContent>
                </Dialog>
            </>)}
        </>
    );
}

export default React.memo(withRouter(Popup));